import PropTypes from 'prop-types';
import React from 'react';

// MUI
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';

import { TextField } from '@mui/material';
import ReadOnlyField from 'components/Transactions/ReadOnlyField';
// CUSTOM
import { clrFieldOptions } from 'data/transactions/config';

const menuItems = clrFieldOptions.options
  .filter((option) => option.menu)
  .map((option) => (
    <MenuItem key={option.state} value={option.state}>
      {option.label}
    </MenuItem>
  ));

function StatusField(props) {
  const { status, onChange, className, readOnly, margin = 'normal', ...otherProps } = props;

  const currentOption = clrFieldOptions?.options?.find((option) => option.state === status);

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  let field = (
    <FormControl className={className} margin='normal' variant='filled'>
      <TextField select label='Status' id='status-select' value={status} onChange={handleChange} variant='filled'>
        {menuItems}
      </TextField>
    </FormControl>
  );

  if (readOnly) {
    field = (
      <ReadOnlyField
        label='Status'
        value={currentOption?.label || status}
        className={className}
        variant='filled'
        margin={margin}
        {...otherProps}
      />
    );
  }

  return field;
}

StatusField.propTypes = {
  status: PropTypes.any,
  onChange: PropTypes.func,
  className: PropTypes.string,
  margin: PropTypes.string,
  readOnly: PropTypes.bool,
  variant: PropTypes.string,
};

export default StatusField;
